import { omitBy } from 'lodash-es';
import type { ConnectedTypes } from '../../make-connected';
import { getVertexId } from '../../../core/util';
import { parseDayIndices } from './util/parse-days';
import type { Types } from '../../types';
import { idOf } from './util/util';

export function fromLocations (
  locations: ConnectedTypes.location[],
  settings:  ConnectedTypes.divisionSettings,
  options:   Types.parsedToOptions
) {

  /**
   * IMPORTANT: do NOT filter out excluded locations based on partial schedule options as frozen events still reference excluded locations.
   */
  return locations
    .map(location => {
      const id = getVertexId(location, options);

      const doc: Types.Entities.Dependency = {
        id,
        minBreakDuration: location.minBreakLength,
        days:             parseDayIndices(location.days, settings),
        intervals:        [[{ start: 0, end: 24.00 }]],  // as there is currently no way to specify intervals for locations
        blockedTimes:     location.lockedTimes?.map(x => idOf.lockedTime(x, options)),
      };

      if (options.includeEntityMeta) {
        doc.name = location.displayName;
      }

      return omitBy(doc, x => x == null) as Types.Entities.Dependency;
    });
}